import React, { useCallback, useState } from "react";
import {
  AHSeparator,
  AHText,
  AHTextFonts,
  Box,
  Card,
  SectionHeader,
  TouchableBox,
} from "arkh";
import {
  Task,
  TaskCheck,
  TaskNumber,
  TaskText,
} from "../../State/Routine/types";
import { TaskNumberResponseOptions } from "./TaskNumberResponseOptions";
import { TaskResponseTypeSelect } from "./TaskResponseTypeSelect";
import { FormattedMessage } from "react-intl";
import { TaskSelectedResponseTypeButton } from "./TaskSelectedResponseTypeButton";
import { TaskCheckResponseOptions } from "./TaskCheckResponseOptions";
import { useIntlTokens } from "../../../../components/mobile/useIntlTokens";

export function TaskResponseType(props: {
  task:
    | Pick<TaskNumber, "id" | "goal" | "type" | "unit">
    | Pick<TaskText, "id" | "type">
    | Pick<TaskCheck, "id" | "sentiments" | "type">
    | undefined;
  setType(type: Task["type"]): void;
  taskUpdateGoal(taskId: string, goal: TaskNumber["goal"]): void;
  taskUpdateUnit(taskId: string, unit: TaskNumber["unit"]): void;
  taskUpdateSentiments(
    taskId: string,
    sentiments: TaskCheck["sentiments"]
  ): void;
  goalValue?: number;
  setGoalValue?(_: number): void;
  canChangeType?: boolean;
}) {
  const [pendingType, setPendingType] = useState(false);

  const renderOptions = useCallback(() => {
    if (props.task === undefined || pendingType) {
      return null;
    }

    switch (props.task.type) {
      case "TaskCheck":
        return (
          <>
            <AHSeparator spaceVertical="medium" />
            <TaskCheckResponseOptions
              setType={(type) => {
                if (props.task) {
                  props.taskUpdateSentiments(
                    props.task.id,
                    type === "check" ? ["POSITIVE"] : ["POSITIVE", "NEGATIVE"]
                  );
                }
              }}
              type={props.task.sentiments.length === 1 ? "check" : "posneg"}
            />
          </>
        );
      case "TaskNumber":
        return (
          <>
            <AHSeparator spaceVertical="medium" />
            <TaskNumberResponseOptions
              setGoalValue={props.setGoalValue}
              goalValue={props.goalValue}
              goal={props.task.goal}
              setGoal={(goal) => {
                if (props.task) {
                  props.taskUpdateGoal(props.task.id, goal);
                }
              }}
              unit={props.task.unit}
              setUnit={(unit) => {
                if (props.task) {
                  props.taskUpdateUnit(props.task.id, unit);
                }
              }}
            />
          </>
        );
      case "TaskText":
        return null;
    }
  }, [pendingType, props]);

  const intl_tokens = useIntlTokens();

  return (
    <>
      <SectionHeader
        right={
          props.canChangeType && !pendingType ? (
            <TouchableBox
              onPress={() => {
                setPendingType(true);
              }}
            >
              <AHText
                type="title-small"
                font={AHTextFonts.REGULAR}
                color="primary"
              >
                {intl_tokens.Edit}
              </AHText>
            </TouchableBox>
          ) : undefined
        }
      >
        <SectionHeader.Title>
          <FormattedMessage
            defaultMessage="Response type"
            description="Task Response Type title"
          />
        </SectionHeader.Title>
      </SectionHeader>
      <Card noSpace defaultBorder>
        <Box spaceHorizontal="medium" spaceVertical="medium">
          {props.task === undefined || (props.canChangeType && pendingType) ? (
            <TaskResponseTypeSelect
              onPress={(type) => {
                setPendingType(false);
                props.setType(type);
              }}
            />
          ) : (
            <TaskSelectedResponseTypeButton
              type={{
                __typename: props.task.type,
                ...props.task,
              }}
            />
          )}
        </Box>
        {renderOptions()}
      </Card>
    </>
  );
}
